import { inject, Injectable } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PasswordValidators } from '@utils/password-validators';
import { PasswordForm } from 'src/app/core/interface/password-form.interface';

@Injectable()
export class UserProfileFormService {
  #fb = inject(FormBuilder).nonNullable;

  form = this.#fb.group({
    firstName: this.#fb.control<string>('', [Validators.required]),
    lastName: this.#fb.control<string>('', [Validators.required]),
    email: this.#fb.control<string>({ value: '', disabled: true }),
    role: this.#fb.control<string>({ value: '', disabled: true }),
    password: this.#fb.control<string>('', PasswordValidators.passwordRequired),
    passwordForm: this.#fb.group<PasswordForm>(
      {
        newPassword: this.#fb.control<string>('', PasswordValidators.validatePasswordField),
        confirmPassword: this.#fb.control<string>('', PasswordValidators.passwordMatch),
      },
      {
        validators: [
          PasswordValidators.passwordCharactersLength(8),
          PasswordValidators.passwordCapitalLetter,
          PasswordValidators.passwordLowercaseLetter,
          PasswordValidators.passwordSymbol,
          PasswordValidators.passwordNumbers,
        ],
        updateOn: 'change',
      },
    ),
  });
}
